// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2VAKP","consentsList":"PatientConsents_consentsList__zUJ1d","consentsListEmpty":"PatientConsents_consentsListEmpty__1kT45"};